import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('GAINR crash:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight:'100vh', background:'#1A1A2E', display:'flex',
          flexDirection:'column', alignItems:'center', justifyContent:'center',
          padding:'24px', fontFamily:'sans-serif', textAlign:'center'
        }}>
          <div style={{fontSize:48, marginBottom:16}}>⚠️</div>
          <div style={{fontWeight:900, fontSize:20, color:'#fff', marginBottom:8}}>
            Something went wrong
          </div>
          <div style={{fontSize:14, color:'rgba(255,255,255,0.5)', marginBottom:28, lineHeight:1.6}}>
            {this.state.error?.message || 'An unexpected error occurred'}
          </div>
          <button
            onClick={()=>{ window.location.href = '/'; }}
            style={{padding:'14px 28px', borderRadius:12, border:'none',
              background:'#FF5C3A', color:'#fff', fontWeight:800,
              fontSize:15, cursor:'pointer'}}>
            Back to GAINR
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
